import { memo, useState, useEffect, useCallback } from 'react';
import FileDownload from '../../view/list/templates/ActionsTemplate/FileDownload';

const ExcelViewer = memo(({ document, item, isClientFileManager, onLoad }) => {
  const [iFrameUrl, setIframeUrl] = useState('');
  const [loadError, setLoadError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    if (document) {
      try {
        const encodedUrl = encodeURIComponent(document);
        setIframeUrl(`https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`);
        setLoadError(false);
      } catch (error) {
        console.error('Error constructing Excel viewer URL:', error);
        setLoadError(true);
      }
    }
  }, [document]);

  const handleLoad = useCallback(() => {
    setLoadError(false);
    onLoad?.();
  }, [onLoad]);

  const handleRetry = useCallback(() => {
    if (retryCount < 3 && document) {
      setRetryCount((prev) => prev + 1);
      setLoadError(false);
      const encodedUrl = encodeURIComponent(document);
      setIframeUrl(`https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}&t=${Date.now()}`);
    }
  }, [retryCount, document]);

  if (!document) return null;

  return (
    <div className="h-100">
      {item && (
        <FileDownload
          rowData={item}
          isFromFilePreviewModal={true}
          filePreviewModalIconClassName="icon-save p-2 pointer float-end h2 mb-0"
        />
      )}

      {loadError && retryCount >= 3 ? (
        <div className="d-flex flex-column align-items-center justify-content-center h-100 gap-2">
          <p className="text-muted">Unable to preview this file.</p>
          <button className="btn btn-sm btn-outline-primary" onClick={handleRetry}>
            Try again
          </button>
        </div>
      ) : (
        iFrameUrl && (
          <iframe
            key={iFrameUrl}
            src={iFrameUrl}
            className="file-viewer"
            width="1366px"
            height="623px"
            frameBorder="0"
            onLoad={handleLoad}
            onError={handleRetry}
            title={item?.display_name || 'Excel Viewer'}
          />
        )
      )}
    </div>
  );
});

ExcelViewer.displayName = 'ExcelViewer';

export default ExcelViewer;
